import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataTableSortEnum, DataTableStateModel } from 'app/shared/components/dynamic-table/dynamic-table.model';
import { HelperService } from 'app/shared/services/helper.service';

@Injectable({
  providedIn: 'root'
})
export class KnowledgeLibraryService {

  constructor(private http: HttpClient, private helperService: HelperService) { }

  getElkKnowledgelibraryList(data: DataTableStateModel): Observable<any> {
    data = this.helperService.replaceFilterBlanksSelection(data);
    
    let params: any = {
      skipCount: data.showItemsPerPage * (data.pageNumber - 1),
      takeCount: data.showItemsPerPage,
      isOrderByDescending: data.sortingValue.dir === DataTableSortEnum.SORT_DESC ? true : false,
      orderField: data.sortingValue.prop ? data.sortingValue.prop : undefined,
      fieldFilters: data.datatableFilters || []
    };

    const url = `/v1/elksearch-case/search?searchCaseType=Knowledge`;
    return this.http.post(url, params);
  }
}
